import React from 'react';
import PropTypes from 'prop-types';

const StoreFilters = ({
   filters,
   primaryColor,
   onFilterChange,
}) => {
   const options = [
      { name: 'All stories', value: 'all' },
      { name: 'Photos', value: 'image' },
      { name: 'Videos', value: 'video' },
   ]
   return (
      <>
         {
            options.map((option, index) => {
               return (
                  <StoreFiltersItem
                     name={ option.name }
                     key={ index.toString() }
                     isActive={ filters.type === option.value }
                     primaryColor={ primaryColor }
                     onFilterChange={ _ => onFilterChange('type', option.value) }
                  />

               )
            })
         }
      </>
   )
};

const StoreFiltersItem = ({
   name,
   primaryColor,
   isActive,
   onFilterChange,
}) => {
   return (
      <div
         onClick={ e => {
            e.preventDefault();
            onFilterChange()
         } }
         role='presentation'
         style={ isActive ? {
            backgroundColor: primaryColor,
         } : {} }
         className='inline-flex items-center justify-center px-[18px] h-10 cursor-pointer border border-divider dark:border-divider-dark rounded-lg'
      >
         <span className='font-medium text-major dark:text-major-dark text-base leading-[20px] select-none'>
            {name}
         </span>
      </div>
   )
}

StoreFiltersItem.propTypes = {
   name: PropTypes.string,
   primaryColor: PropTypes.string,
   isActive: PropTypes.bool,
   onFilterChange: PropTypes.func,
};
StoreFilters.propTypes = {
   filters: PropTypes.object,
   primaryColor: PropTypes.string,
   onFilterChange: PropTypes.func,

};

export default StoreFilters;
